var render, staticRenderFns
import script from "./DeferredRenderFrame.vue?vue&type=script&lang=js&"
export * from "./DeferredRenderFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d214d47')) {
      api.createRecord('2d214d47', component.options)
    } else {
      api.reload('2d214d47', component.options)
    }
    
  }
}
component.options.__file = "www/vue_components/common/DeferredRenderFrame/DeferredRenderFrame.vue"
export default component.exports